// @ts-nocheck
import { Inertia } from '@inertiajs/inertia';
import firebase from 'firebase/compat/app';
import firebaseApp from '@/Constants/configFirebase';
import 'firebase/compat/auth';
import { EmailRegex } from '@/Constants/regularExpression';
const email = document.getElementById('email');
const password = document.getElementById('password');
const isSchool = document.getElementById('isSchool');
const isExam = document.getElementById('isExam');
const submit = document.getElementById('submit');
const error = document.getElementById('error');
const formElement = document.getElementById('form');
let isSecondClick = false;
const clientLoginSubmit = async () => {
    const errorMessages = [];
    let resultErrorMessage = '';
    let isError = false;
    submit.disabled = true;
    submit.style.cursor = 'not-allowed';
    // 未入力＆フォーマットチェック
    if (!email.value.length) {
        isError = true;
        errorMessages.push('・メールアドレスを入力してください');
    }
    if (!password.value.length) {
        isError = true;
        errorMessages.push('・パスワードを入力してください');
    }
    if (!email.value.match(EmailRegex)) {
        isError = true;
        errorMessages.push('・メールアドレスの形式が正しくありません');
    }
    if (errorMessages.length > 0) {
        for (let i = 0; i < errorMessages.length; i += 1) {
            resultErrorMessage += `<li class="text-red-400">${errorMessages[i]}</li>`;
        }
        error.innerHTML = resultErrorMessage;
        error.style.padding = '6px 4px';
        error.marginBottom = '2px';
    }
    else
        isError = false;
    // ERRORがあれば、処理を中断する
    if (isError) {
        submit.disabled = false;
        submit.style.cursor = 'default';
        return false;
    }
    // 多重ポストを避ける
    if (isSecondClick)
        return false;
    isSecondClick = true;
    // firebase にログイン
    try {
        await firebase.auth(firebaseApp).signInWithEmailAndPassword(email.value, password.value);
        // 正常系
        // uidを受け取れるトークンを取得
        const userToken = await firebase.auth(firebaseApp).currentUser.getIdToken(true);
        const userEmail = await firebase.auth(firebaseApp).currentUser.email;
        // Laravel側の認証
        Inertia.visit('/login', {
            method: 'post',
            data: {
                email: userEmail,
                password: password.value,
                idToken: userToken,
                isSchool: isSchool ? isSchool.value : false,
                isExam: isExam.value ?? false,
            },
        });
    }
    catch (err) {
        isSecondClick = false;
        submit.disabled = false;
        submit.style.cursor = 'default';
        // 異常系
        if (err.code === 'auth/user-not-found') {
            error.innerHTML = '<li class="text-red-400">・ユーザーが存在しません。<br />入力情報を再度確認ください。</li>';
        }
        if (err.code === 'auth/wrong-password') {
            error.innerHTML = '<li class="text-red-400">・パスワードに誤りがあります。<br />確認いただき再度ログインをお願いします。</li>';
        }
        return false;
    }
    return false;
};
formElement.addEventListener('submit', clientLoginSubmit);
